// Last-seen announcement id is stored in a cookie (not localStorage) because
// App.jsx wipes localStorage on browser close — a cookie ensures each
// announcement is shown exactly once per user, ever. A new announcement id
// still triggers the modal once.
const COOKIE_NAME = "sulhafa_last_announcement_id";
const TEN_YEARS_IN_DAYS = 3650;

const getCookie = (name) => {
  const match = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return match ? decodeURIComponent(match[1]) : null;
};

const setCookie = (name, value, days) => {
  const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
};

export const getLastSeenAnnouncementId = () => {
  return getCookie(COOKIE_NAME);
};

export const setLastSeenAnnouncementId = (id) => {
  if (id === null || id === undefined || id === "") return;
  setCookie(COOKIE_NAME, String(id), TEN_YEARS_IN_DAYS);
};
